module.exports = __webpack_public_path__ + "static/media/sub_morelike.078959ca.png";